import { createContext } from 'react'
import type { LangFn } from '@spa/types/lang.types'

export const LangContext = createContext<LangFn>((key) => key)
